export default "__VITE_ASSET__5cc37788__"